module.exports = "/static/js/3c5843e3eeed69a2473f0589a97d4591.png";